// Material Dashboard 2 React components
import MDBox from "components/MDBox"
// Asistencia page components
import AsistenciaItem from "layouts/asistencia/components/AsistenciaItem"
import PropTypes from "prop-types"

function AsistenciaInformation({ asistentes, onReload }) {
  return (
    <MDBox pt={1} pb={2} px={2}>
      {asistentes?.map((item) => (
        <div key={item.id}>
          <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
            <AsistenciaItem
              key={item.id}
              id={item.id}
              nombre={item.nombre}
              documentNumber={item.documentNumber}
              organizacion={item.dependenciaNombre}
              tipoAsistente={item.tipoAsistenteNombre}
              legajo={item.legajo}
              onReload={onReload}
            />
          </MDBox>
          <hr></hr>
        </div>
      ))}
    </MDBox>
  )
}

AsistenciaInformation.propTypes = {
  asistentes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReload: PropTypes.func.isRequired,
}

export default AsistenciaInformation
